import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react"
import { useAuth } from "react-oidc-context";

export interface TokenInformation {
    'SD.Location.isSdLocation': string | boolean;
    'Tenant.Code': string[];
    name: string;
    role: string[];
  }


const useAuthToken = () => {
    const [user, setUser] = useState<TokenInformation | null>(null);
    const auth = useAuth();

    useEffect(() => {

        const token = auth.user?.access_token;
        if(token) {
            const decodedToken = jwtDecode<TokenInformation>(token);
            setUser(decodedToken);
        }
        else {
            setUser(null);
        }
    }, [auth]);

    return user;
}

export default useAuthToken;